import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import "./Marketing.scss";
class Marketing extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <section className="hot-features-area">
          <div className="container animated bounceInUp">
            <div
              className="section-header-2 wow fadeIn"
              data-wow-offset={10}
              data-wow-duration="1.5s"
            >
              <div className="section-description" style={{ zIndex: 999 }}>
                <p className="features-title">
                  <span>
                    <span style={{ fontWeight: 600 }}>
                      <FormattedMessage id="home.marketing.a1" />
                    </span>{" "}
                    <FormattedMessage id="home.marketing.a2" />
                  </span>
                </p>
              </div>
            </div>
            <div
              className="row hot-features"
              style={{ padding: 0, position: "relative" }}
            >
              <div className="dealer-box">
                <div className="indicator">
                  <FormattedMessage id="home.marketing.a3" />
                  <div>
                    <FormattedMessage id="home.marketing.a4" />
                  </div>
                </div>
                <div className="indicator">
                  <FormattedMessage id="home.marketing.a5" />
                  <div>
                    <FormattedMessage id="home.marketing.a6" />
                  </div>
                </div>
                <div className="indicator">
                  350+
                  <div>
                    <FormattedMessage id="home.marketing.a8" />
                  </div>
                </div>
                <div className="indicator">
                  <FormattedMessage id="home.marketing.a9" />
                  <div>
                    <FormattedMessage id="home.marketing.a10" />
                  </div>
                </div>
                <div className="indicator">
                  <FormattedMessage id="home.marketing.a11" />
                  <div>
                    <FormattedMessage id="home.marketing.a12" />
                  </div>
                </div>
              </div>
              <img
                className="img-responsive map-img"
                src="/static/images/map.png"
                data-src="/static/images/map.png"
                alt=""
              />
            </div>
          </div>
        </section>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Marketing)
);
